import { type ReactNode } from 'react'

import { Skeleton } from '~/components/component-library'
import { TransactionDialogLoadingContent } from '~/components/smart-accounts/TransactionDialogLoadingContent'

export const TransactionPageLayout = ({
  children,
  footer,
}: {
  children: ReactNode
  footer?: ReactNode
}) => (
  <div className="flex w-full flex-col items-center space-y-8 bg-surface p-4 pb-12 md:p-0 md:pb-12 md:pt-16">
    <div className="relative w-full px-4 py-4 md:max-w-md md:rounded-2xl md:border md:border-muted md:p-8">
      {children}
    </div>
    {footer}
  </div>
)

const TransactionPageLoadingSkeleton = () => (
  <TransactionPageLayout>
    <div className="mt-4 space-y-12 md:mt-8">
      <Skeleton length={20} />
      <div className="mx-auto space-y-8 px-0 py-4 md:max-w-lg md:rounded-2xl md:px-6 md:py-12">
        <TransactionDialogLoadingContent />
      </div>
    </div>
  </TransactionPageLayout>
)

export { TransactionPageLoadingSkeleton }
